import script from "./CustomizerMini.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomizerMini.vue?vue&type=script&lang=ts&setup=true"

import "./CustomizerMini.vue?vue&type=style&index=0&id=12659b71&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12659b71"]])

export default __exports__